import * as types from 'constants/ActionTypes';
import { save, read, list, create } from 'utils/Api';
import omit from 'lodash/omit';
import get from 'lodash/get';

export const setStatus = status => ({
  type: types.SET_TAX_CARD_STATUS,
  status,
});

export const setTaxCardInfo = taxCardInfo => ({
  type: types.SET_TAX_CARD_INFO,
  taxCardInfo,
});

export const requestTaxCardInfo = () =>
  (dispatch, getState) => {
    const {
      loginReducer: { user: { token } },
      EmployeeTaxCardsReducer: { taxCardInfo },
      WebValuesReducer: { valuesByKey },
    } = getState();
    const templateConfig = valuesByKey['Info.EmployeeMasterTaxCard.XapEmailTemplateID'];
    if (!taxCardInfo &&
      templateConfig &&
      templateConfig.Value
    ) {
      const config = {
        entity: 'XapEmailTemplate',
        entityID: Number(templateConfig.Value),
        headers: { Authorization: `Bearer ${token}` },
      };
      return read(config)
        .then(({ data }) => dispatch(setTaxCardInfo(data)));
    }
    return null;
  };

export const setTaxDiscount = (taxDiscount = 0) => ({
  type: types.SET_TAX_DISCOUNT,
  taxDiscount,
});

export const requestTaxDiscountInfo = () =>
  (dispatch, getState) => {
    const {
      EmployeeTaxCardsReducer: { taxDiscount },
      loginReducer: { user: { token } },
    } = getState();
    if (!taxDiscount) {
      const now = new Date().toISOString();
      const config = {
        entity: 'PayTax',
        headers: { Authorization: `Bearer${token}` },
        params: {
          $filter: `PayTaxBegda le datetime'${now}' and PayTaxEndda ge datetime'${now}'`,
          $select: 'TaxDiscountMonth',
        },
      };

      return list(config)
        .then(({ data }) => dispatch(setTaxDiscount(get(data, '[0].TaxDiscountMonth'))));
    }
    return null;
  };

export const requestTaxCards = () => ({
  type: types.REQUEST_TAX_CARDS,
});

export const requestTaxCardsSuccess = taxCards => ({
  type: types.REQUEST_TAX_CARDS_SUCCESS,
  taxCards,
});

export const requestTaxCardsFailure = error => ({
  type: types.REQUEST_TAX_CARDS_FAILURE,
  error,
});

export const fetchTaxCards = () =>
  (dispatch, getState) => {
    dispatch(requestTaxCards());
    dispatch(requestTaxCardInfo());
    dispatch(requestTaxDiscountInfo());
    const now = new Date().toISOString();
    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();
    const config = {
      entity: 'EmployeeMasterTaxCard',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `EmployeeMasterID eq ${EmployeeMasterID} and Begda le datetime'${now}' and Endda ge datetime'${now}'`,
      },
    };

    return list(config)
      .then(({ data }) => dispatch(requestTaxCardsSuccess(data)))
      .catch(err => dispatch(requestTaxCardsFailure(err)));
  };

export const requestCreateTaxCards = () => ({
  type: types.REQUEST_CREATE_TAX_CARDS,
});

export const requestCreateTaxCardsSuccess = data => ({
  type: types.REQUEST_CREATE_TAX_CARDS_SUCCESS,
  data,
});

export const requestCreateTaxCardsFailure = error => ({
  type: types.REQUEST_CREATE_TAX_CARDS_FAILURE,
  error,
});

export const createTaxCard = ({
  TaxCardType, Unused, Prosent, DateLastUsed,
}) =>
  (dispatch, getState) => {
    dispatch(requestCreateTaxCards());

    const DateIn = new Date().toISOString();
    const Begda = DateIn;
    const Endda = new Date('9999/12/31').toISOString();
    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

    const config = {
      entity: 'EmployeeMasterTaxCard',
      headers: { Authorization: `Bearer ${token}` },
      data: {
        EmployeeMasterID,
        DateIn,
        Begda,
        Endda,
        TaxCardType,
        Unused,
        Prosent,
        DateLastUsed,
      },
    };

    return create(config)
      .then(res => dispatch(requestCreateTaxCardsSuccess(res.data)))
      .catch(err => dispatch(requestCreateTaxCardsFailure(err)));
  };


export const requestTaxCardUpdate = () => ({
  type: types.REQUEST_UPDATE_TAX_CARD,
});

export const requestTaxCardUpdateSuccess = data => ({
  type: types.REQUEST_UPDATE_TAX_CARD_SUCCESS,
  data,
});

export const requestTaxCardUpdateFailure = error => ({
  type: types.REQUEST_UPDATE_TAX_CARD_FAILURE,
  error,
});

export const update = card =>
  (dispatch, getState) => {
    dispatch(setStatus({ id: card.TaxCardType, value: 'TAX_CARD_SAVING' }));
    const data = omit(card, ['EmployeeMaster', 'EntityId', 'KeyID', 'ModifyDate', 'RowVersion', 'UniqueID']);
    const { loginReducer: { user: { token } } } = getState();
    const config = {
      entity: 'EmployeeMasterTaxCard',
      headers: { Authorization: `Bearer ${token}` },
      data,
    };
    return save(config)
      .then(res => dispatch(requestTaxCardUpdateSuccess(res.data)))
      .catch(err => dispatch(requestTaxCardUpdateFailure(err)));
  };



// WEBPACK FOOTER //
// ./src/actions/EmployeeTaxCards.js